import React from 'react';

import {cx} from 'emotion';
import PropTypes from 'prop-types';

import {ReactComponent as FullLogo} from 'static/images/icons/logos/Newsela_fulllogo_reducedsize_RGB.svg';
import {ReactComponent as LogoMark} from 'static/images/icons/logos/Newsela_mark_reducedsize_RGB.svg';

import {
  logoMarkStyle
} from './style';

const propTypes = {
  additionalClassName: PropTypes.string,
  fullSizeMediaQuery: PropTypes.string,
  showFullSize: PropTypes.bool,
  title: PropTypes.string,
};

export const Logo = React.forwardRef((props, ref) => {
  const {title = 'Newsela company logo'} = props;
  const svgProps = {
    'data-qa-selector': 'header_logo',
    'aria-hidden': 'true'
  };
  const className = cx([
    logoMarkStyle(props.showFullSize, props.fullSizeMediaQuery),
    props.additionalClassName
  ]);


  return (
    <div
      ref={ref}
      className={className}
      aria-hidden="true"
      aria-label={title}
    >
      <FullLogo
        {...svgProps}
      />
      <LogoMark
        {...svgProps}
      />
    </div>
  );
});

Logo.propTypes = propTypes;
export default Logo;
